
import { generateThemeTitle } from '@/composables/redpack'
import config from '@/config'
import { Tools } from '@/plugins/tools'
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: {
    greetings: {
      type: String,
      required: true
    },
    skinImage: {
      type: String,
      default: config.skinImage
    }
  },

  setup (props) {
    const greetingCheck = computed(() => props.greetings || generateThemeTitle())

    const greetingStyle = computed(() => {
      // const remFontSize = 37.5

      const fontSize = Tools.byteLength(greetingCheck.value) > 16 ? 24 : 32

      return {
        fontSize: fontSize + 'px'
      }
    })

    return {
      greetingCheck,
      greetingStyle,
      publicPath: process.env.BASE_URL
    }
  }
})
